import { LicenseManager } from "@ag-grid-enterprise/core";
/* global window, MutationObserver */
import { Controller } from "stimulus";

import "../entrypoints/ClientNotification/clientNotificationService.ts";

let licenseRegistered = false;

// Bootstraps the Power Scheduler AG grid for an order's Schedule tab. Lives on
// the `#scheduler-container` element rendered by `_scheduled_tab.html.haml`,
// so `connect()` fires once per turbo-frame load on both the legacy Haml show
// page and the Vue/Inertia show page — sidestepping the ES-module dedup that
// blocked the previous module-side bootstrap on revisits.
//
// TODO(PT-3107): Delete this controller when the legacy order show is retired.
export default class extends Controller {
  async connect() {
    if (!licenseRegistered) {
      LicenseManager.setLicenseKey(window.AG_GRID_LICENSE_KEY);
      licenseRegistered = true;
    }

    // jQuery custom event from the manual "Add to Power Scheduler" flow in
    // `_scheduled_tab.html.haml`. Removed in disconnect() to avoid stacking
    // listeners across re-loads of the partial.
    this.handleStartWith = (_event, workTypeGridData) => {
      this.bootstrap(workTypeGridData);
    };

    $(this.element).on("startWith", this.handleStartWith);

    if (!this.element.classList.contains("hidden")) {
      await this.bootstrap();
    }

    // On the Vue/Inertia route, Reka UI hides inactive tabs with CSS
    // (data-state="inactive") rather than unmounting them, so disconnect()
    // never fires on tab switch. Watch the ancestor tab panel for that
    // attribute change and close the slideout immediately. On the legacy
    // route no [data-state] ancestor exists, so this observer is never set up
    // and the existing Bootstrap hide.bs.tab handler in ImprintScheduler
    // continues to own that behaviour.
    const tabPanel = this.element.closest("[data-state]");

    if (tabPanel) {
      this.tabObserver = new MutationObserver(() => {
        if (tabPanel.dataset.state === "inactive") {
          this.scheduler?.imprintSlideout?.close();
        }
      });
      this.tabObserver.observe(tabPanel, {
        attributes: true,
        attributeFilter: ["data-state"],
      });
    }
  }

  disconnect() {
    if (this.handleStartWith) {
      $(this.element).off("startWith", this.handleStartWith);
    }

    this.tabObserver?.disconnect();
    this.scheduler?.unbindAll();
    this.scheduler?.imprintSlideout?.close();
  }

  async bootstrap(workTypeGridData) {
    const { default: ImprintScheduler } = await import("../src/components/Scheduler/Grids/ImprintScheduler.ts");
    this.scheduler = new ImprintScheduler();
    this.scheduler.startWith(workTypeGridData);
  }
}
